import Icon from "~/components/shared/Icon";
import { twMerge } from "tailwind-merge";
import Count from "~/components/build/Show/components/Count";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { getAnnotationCounts } from "~/components/build/Show/lib/annotationCounts";
import { useBuildStore } from "~/components/build/Show/lib/useBuildStore";

export default function AnnotationsPanelToggle() {
  const { build } = useBuild();
  const totalCount = getAnnotationCounts(build).totalCount;
  const isOpen = useBuildStore((state) => state.annotationsPanelOpen);
  const toggle = useBuildStore((state) => state.toggleAnnotationsPanel);

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="AnnotationsPanelToggle"
      aria-pressed={isOpen}
      title={isOpen ? "Close annotations panel" : "Open annotations panel"}
      className={twMerge(
        "flex items-center justify-center gap-1 rounded-sm border border-slate-400 px-1.5 py-0.5 text-sm font-normal active:bg-gray-300 active:shadow-inner",
        isOpen
          ? "border-purple-300 bg-purple-100 text-purple-600 active:bg-purple-100"
          : "hover:border-slate-500 hover:bg-gray-100",
      )}
    >
      <Icon icon="sticky-note" style={{ fill: "none" }} className="h-3.5 w-3.5" />
      <span>Annotations</span>
      {totalCount > 0 && (
        <span className="ml-1">
          <Count data-testid="AnnotationsPanelToggle-count">{totalCount}</Count>
        </span>
      )}
    </button>
  );
}
